import { ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  show: boolean = false;
  splash: boolean = false;

  constructor() {}

  start(splash?: boolean) {
    this.show = true;
    this.splash = splash ?? false;
  }

  stop() {
    this.show = false;
    this.splash = false;
  }
}
